export const extractProviderMessageId = (value: any): string | null => {
    if (!value) return null;
    if (typeof value !== 'object') return null;
    const direct = value.id || value.messageId || value.message_id || value.zaapId || value.wamid;
    if (direct) return String(direct);
    for (const key of ['response', 'data', 'payload', 'message', 'messages', 'waha_response']) {
      const nested = extractProviderMessageId(value[key]);
      if (nested) return nested;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        const nested = extractProviderMessageId(item);
        if (nested) return nested;
      }
    }
    return null;
  };
